import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/AppLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ToastProvider } from "./components/Toast";
import { AlertsPage } from "./pages/AlertsPage";
import { ConnectPage } from "./pages/ConnectPage";
import { DiagnosisFinderPage } from "./pages/DiagnosisFinderPage";
import { EditProfilePage } from "./pages/EditProfilePage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { PatientDetailPage } from "./pages/PatientDetailPage";
import { PatientRegistrationPage } from "./pages/PatientRegistrationPage";
import { PlanPage } from "./pages/PlanPage";
import { PlanSetupPage } from "./pages/PlanSetupPage";
import { ProfilePage } from "./pages/ProfilePage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SignupPage } from "./pages/SignupPage";
import { VitalsHistoryPage } from "./pages/VitalsHistoryPage";
import { useAuthStore } from "./stores/authStore";

function App() {
  const initAuth = useAuthStore((state) => state.initAuth);

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/alerts" element={<AlertsPage />} />
              <Route path="/connect" element={<ConnectPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/edit" element={<EditProfilePage />} />
              <Route
                path="/patients/register"
                element={<PatientRegistrationPage />}
              />
              <Route path="/patients/:userId" element={<PatientDetailPage />} />
              <Route
                path="/patients/:userId/vitals"
                element={<VitalsHistoryPage />}
              />
              <Route path="/plans/setup" element={<PlanSetupPage />} />
              <Route path="/plans/:planId" element={<PlanPage />} />
              <Route path="/diagnoses" element={<DiagnosisFinderPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
